'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendOrderButton = function (_Component) {
    (0, _inherits3.default)(SendOrderButton, _Component);

    function SendOrderButton() {
        (0, _classCallCheck3.default)(this, SendOrderButton);
        return (0, _possibleConstructorReturn3.default)(this, (SendOrderButton.__proto__ || (0, _getPrototypeOf2.default)(SendOrderButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SendOrderButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$canCreateOrder = _props.canCreateOrder,
                canCreateOrder = _props$canCreateOrder === undefined ? false : _props$canCreateOrder,
                _props$offlineMode = _props.offlineMode,
                offlineMode = _props$offlineMode === undefined ? false : _props$offlineMode,
                _props$offlineModeMes = _props.offlineModeMessage,
                offlineModeMessage = _props$offlineModeMes === undefined ? '' : _props$offlineModeMes,
                sendOrderDisabledReason = _props.sendOrderDisabledReason;


            var btnClass = !canCreateOrder ? 'btn btn-default btn-orange btn-lg disabled' : 'btn btn-default btn-orange btn-lg';

            return _react2.default.createElement(
                'div',
                { className: 'text-center cart-submit-btn-wrap' },
                !offlineMode ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: (0, _config2.default)().url.cartSummary({}), className: btnClass, disabled: !canCreateOrder },
                        (0, _localize2.default)("App:OrderCompletion"),
                        ' \xA0 ',
                        _react2.default.createElement('i', { className: 'fa fa-arrow-right' })
                    ),
                    !canCreateOrder && !sendOrderDisabledReason ? _react2.default.createElement(
                        'p',
                        { className: 'block-title-1 red' },
                        sendOrderDisabledReason
                    ) : null
                ) : _react2.default.createElement(
                    'p',
                    { className: 'block-title-1 red' },
                    offlineModeMessage || (0, _localize2.default)("App:OrderingSuspended")
                )
            );
        }
    }]);
    return SendOrderButton;
}(_react.Component);

SendOrderButton.propTypes = {
    canCreateOrder: _propTypes2.default.bool,
    offlineMode: _propTypes2.default.bool,
    offlineModeMessage: _propTypes2.default.string
};

function mapStateToProps(state) {
    return {
        canCreateOrder: state.cart.canCreateOrder,
        offlineMode: state.cart.offlineMode,
        offlineModeMessage: state.cart.offlineModeMessage
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SendOrderButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/SendOrderButton.js
// module id = 905
// module chunks = 0